import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrdineLavoro, Utente, TipoCliente, TipoIntervento, Mezzo, Autista, Commessa } from '../def/structures';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { DBFirestoreService } from '../dbfirestore.service';
import { EventDeleteOrdine, EventEditOrdine, ODLErrorMessages } from '../def/types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'odl-modal-day',
    templateUrl: './odl-modal-day.component.html',
    styleUrls: ['./odl-modal-day.component.scss']
})
export class OdlModalDayComponent implements OnInit, OnChanges {
    
    private unsubscribe$ = new Subject<void>();

    private _data: any;
    public ordine: OrdineLavoro;
    private commessa: Commessa;

    private updated_observable$: Subject<{ordine:any,commessa:any}>;

    public faPrint = faPrint;
    @ViewChild('editForm', {static:false}) editForm: NgForm;

    autisti: Autista[];
    mezzi: Mezzo[];

    constructor(
        public activeModal: NgbActiveModal,
        private db: DBFirestoreService,
    ) { }

    getData() {
        return this._data;
    }

    @Input()
    setData(data) {
        this._data = data;
        this.ordine = {
            id: data.ordine.id,
            rif_commessa: data.ordine.rif_commessa,

            confermato: data.ordine.confermato,
            giorno_ora: data.ordine.giorno_ora,
            durata_prevista: data.ordine.durata_prevista,

            caposquadra: data.ordine.caposquadra,
            autista: data.ordine.autista,            
            mezzo: data.ordine.mezzo,
            
            attrezzi: data.ordine.attrezzi,            
            indirizzo: data.ordine.indirizzo ? data.ordine.indirizzo : data.commessa.indirizzo,
            localita: data.ordine.localita ? data.ordine.localita : data.commessa.localita,
            persona_riferimento: data.ordine.persona_riferimento ? data.ordine.persona_riferimento : data.commessa.persona_riferimento,
            telefono: data.ordine.telefono ? data.ordine.telefono : data.commessa.telefono,

            note: data.ordine.note ? data.ordine.note : data.commessa.note,

            tipo_intervento: data.commessa.tipo_intervento ? data.commessa.tipo_intervento.id :data.ordine.tipo_intervento,
            tipo_cliente: data.commessa.tipo_cliente ? data.commessa.tipo_cliente.id : data.ordine.tipo_cliente,
        }
        this.commessa = data.commessa;
        this.updated_observable$ = data.updated_observable;
    }
    ngOnInit() {
        this.db.collectionCachedAutisti()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(results => this.autisti = results);

        this.db.collectionCachedMezzi()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(results => this.mezzi = results);
    }

    setOra(orario: string) {
        const [hour, minutes] = orario.split(':');
        const update_time = new Date(this.ordine.giorno_ora.getTime());
        update_time.setHours(parseInt(hour));
        update_time.setMinutes(parseInt(minutes));
        /*
        this.ordine.giorno_ora.setHours(parseInt(hour));
        this.ordine.giorno_ora.setMinutes(parseInt(minutes));
        */
        this.ordine.giorno_ora = update_time;
    }

    onDelete() {
        const confirmed = confirm('Eliminare la programmazione del giorno per l\'ordine corrente?');
        if ( confirmed ) {
            const retVal: EventDeleteOrdine = {
                type : 'delete',
                id : this.ordine.id,
                parent_id : this.commessa.id
            }
            this.activeModal.close(retVal);
        }
    }

    onSave() {
        const retVal: EventEditOrdine = {
            type: 'edit',
            id: this.ordine.id,
            parent_id: this.commessa.id,
            data: this.ordine,
        }

        this.db.updateOrdine(retVal.data).then( () => {
            this.updated_observable$.next({ordine: this.ordine, commessa: this.commessa});
            this.editForm.form.markAsPristine();

        }).catch( error => {
            this.onError({ title: 'Errore aggiornamento', details: error });
        });
        // this.activeModal.close(retVal);
    }

    ngOnChanges() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    onError(error: ODLErrorMessages) {
        alert(error.title)
        console.log(error);
    }

}
